import React from 'react';
import { Provider } from 'react-redux';
import store from './stores';
import '@myob/myob-styles/dist/styles/myob-clean.css';
import { Body, globalCss } from './App.styles';
import { ConnectedRouter } from 'connected-react-router';
import { history } from './appHistory';
import Routes from './router';
import { saveBusinessId } from './helpers/query';
import { Global } from '@emotion/core';

export default function Root() {
    saveBusinessId();
    return (
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <Global styles={globalCss} />
                <Body>
                    <Routes />
                </Body>
            </ConnectedRouter>
        </Provider>
    );
}
